import { useEffect, useState } from 'react';

type UseHeaderReturn = {
  isScrolled: boolean;
  isHeaderVisible: boolean;
};

const WINDOW_SCROLL_Y = 0;
const SCROLL_THRESHOLD = 10;

export const useHeader = (): UseHeaderReturn => {
  const [scrolled, setScrolled] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setScrolled(currentScrollY > WINDOW_SCROLL_Y);

      const isScrollingDown = currentScrollY > lastScrollY;
      const isScrollingUp = currentScrollY < lastScrollY;

      const scrollDifference = Math.abs(currentScrollY - lastScrollY);

      if (scrollDifference < SCROLL_THRESHOLD) {
        return;
      }

      if (currentScrollY <= 10) {
        setIsHeaderVisible(true);
      } else if (isScrollingDown) {
        setIsHeaderVisible(false);
      } else if (isScrollingUp) {
        setIsHeaderVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return {
    isScrolled: scrolled,
    isHeaderVisible,
  };
};
